import {
  AutocompleteInput,
  NumberInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const sizePriceAdditionFilterList = (permissions) => {
  const defaultFilter = [
    // <TextInput
    //   source="all"
    //   label="mine.filter.search_all"
    //   alwaysOn
    //   resettable
    //   variant="outlined"
    //   InputProps={{
    //     endAdornment: (
    //       <InputAdornment position="end">
    //         <SearchIcon />
    //       </InputAdornment>
    //     ),
    //   }}
    // />,
    <TextInput
      alwaysOn
      source="size"
      label="mine.label.size"
      resettable
      variant="outlined"
    />,
    <NumberInput
      alwaysOn
      source="price"
      label="mine.label.price"
      variant="outlined"
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default sizePriceAdditionFilterList;
